import { render, staticRenderFns } from "./gl-account.vue?vue&type=template&id=32770706"
import script from "./gl-account.vue?vue&type=script&lang=js"
export * from "./gl-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports